<template>  	
    <div>    
		<p v-if="error == false && !errorLower && !errorUpper" id="recommendation" class="txt--xl h3">
			<strong>Summary:</strong> {{result.text}} risk of malnutrition
		</p>
		<p v-if="error == false && !errorLower && !errorUpper" id="total-score">
			<strong>Total MUST Score</strong> : {{result.score}}
		</p>
		<p v-if="error == true || errorLower || errorUpper" id="total-score-na">
			<strong>Total MUST Score</strong> : N/A
		</p>

		<p v-if="errorWeight" class="danger-text"><strong>The adjusted/unadjusted weight loss is 2st 6lb (15.4kg) or more. Please check weights, oedema and amputations as appropriate.</strong></p>
		<p v-if="errorUpper && !errorLower" class="danger-text"><strong>You have indicated that the patient has more than two arms or arm segments amputated.</strong></p>
		<p v-if="errorLower && !errorUpper" class="danger-text"><strong>You have indicated that the patient has more than two legs or leg segments amputated.</strong></p>
		<p v-if="errorLower && errorUpper" class="danger-text"><strong>You have indicated that the patient has more than two arms/ arm segments  or more than two legs/leg segments amputated.</strong></p>

		<table id="results" class="tbl table">
			<tr>
				<th>Measure</th>
				<th>Result</th>
				<th>Score</th>
			</tr>
			<tr>
				<td>BMI</td>
				<td v-if="result.bmi != null && !errorLower && !errorUpper && !errorBmi">{{result.bmi}}</td>
				<td v-else>N/A</td>
				<td v-if="result.bmiScore != null && !errorLower && !errorUpper && !errorBmi">{{result.bmiScore}}</td>
				<td v-else>N/A</td>
			</tr>
			<tr>
				<td>Unplanned Weight Loss</td>
				<td v-if="result.weightPercentage != null && !errorLower && !errorUpper && !errorWeightLoss">{{result.weightPercentage}} %</td>
				<td v-else>N/A</td>
				<td v-if="result.weightScore != null && !errorLower && !errorUpper && !errorWeightLoss">{{result.weightScore}}</td>
				<td v-else>N/A</td>
			</tr>
			<tr>
				<td>ADE</td>
				<td v-if="answers.acuteDiseaseEffect.value != null">{{answers.acuteDiseaseEffect.text}}</td>
				<td v-else>N/A</td>
				<td v-if="result.adeScore != null">{{result.adeScore}}</td>
				<td v-else>N/A</td>
			</tr>
		</table>
    </div>
</template>

<script>

export default {
	name: "Responses",
    props: {
        answers: Object,
		result: Object,
		error: Boolean,
		errorWeight: Boolean,
		errorUpper: Boolean,
        errorLower: Boolean,
		errorBmi: Boolean,
		errorWeightLoss: Boolean
    }
};
</script>
